// Monitoring services configuration
// This file contains environment-specific configurations for Grafana and Prometheus
// NOTE: Credentials are now stored server-side - use backend proxy endpoints

interface MonitoringConfig {
  grafana: {
    url: string;
  };
  prometheus: {
    // Use backend proxy - credentials stored server-side
    proxyUrl: string;
  };
  backend: {
    url: string;
  };
}

// Use relative paths for all environments
// In development, these will be proxied to localhost services
// In production, these will resolve to the current domain
const config: MonitoringConfig = {
  grafana: {
    url: '/grafana',
  },
  prometheus: {
    // Prometheus queries go through backend proxy at /api3.2/sense/prometheus
    proxyUrl: '/api3.2/sense/prometheus',
  },
  backend: {
    url: '' // Empty string means use same origin, just like axiosInstance
  }
};

export default config;